module.exports = __webpack_public_path__ + "img/normal-xue3.6a663fee.png";